<template>
  <div class="c-jobsPicker">
    <div class="c-jobsPicker_jobs">
      <ul class="c-jobListLv1">
        <li
          class="c-jobListLv1_item"
          v-for="(job, index) in jobs"
          :key="index"
        >
          <b-collapse
            :open.sync="collapseStatuses[index].isCollapsed"
            animation=""
          >
            <a
              href="javascript:;"
              class="c-jobListLv1_title"
              :class="{ 'c-jobListLv1_collapsed': collapseStatuses[index].isCollapsed }"
              slot="trigger"
            >
              <coconala-icon
                :name="collapseStatuses[index].isCollapsed ? 'chevron-down' : 'chevron-right'"
                size="12px"
              />
              {{ job.title }}
            </a>
            <ul class="c-jobListLv2">
              <li
                class="c-jobListLv2_item"
                v-for="(subJob, indexS) in job.subJobs"
                :key="indexS"
              >
                <span class="c-jobListLv2_title">
                  {{ subJob.title }}
                </span>
                <ul class="c-jobListLv3">
                  <li
                    class="c-jobListLv3_item"
                    v-for="(subSubJob, indexSS) in subJob.subJobs"
                    :key="indexSS"
                  >
                    <span class="c-jobListLv3_title">
                      <c-checkbox
                        size="is-small"
                        v-model="attributes.userJobs"
                        :native-value="subSubJob.id"
                      >
                        {{ subSubJob.title }}
                      </c-checkbox>
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </b-collapse>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    jobs: {
      type: Array
    },
    userJobs: {
      type: Array
    }
  },
  data() {
    const userJobs = this.$util.clone(this.userJobs)
    // 1件のjobのjob.subJobs.subJobsにチェックが1つでもあるかどうか判定する
    const doesCheckExists = job =>
      job.subJobs.filter(subJob => {
        return (
          subJob.subJobs.filter(subSubJob => {
            return this.userJobs.includes(subSubJob.id)
          }).length > 0
        )
      }).length > 0

    return {
      collapseStatuses: this.jobs.map(job => {
        return new Object({ isCollapsed: doesCheckExists(job) })
      }),
      attributes: {
        userJobs
      }
    }
  },
  watch: {
    'attributes.userJobs': function() {
      this.$emit('input', this.attributes.userJobs)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-jobsPicker {
  user-select: none;
  &_jobs {
    margin-top: 10px;
  }
}
.c-currentJobList {
  background-color: $color-gray-50;
  padding: 10px;
  &_item {
    display: inline-block;
    &:not(:last-child)::after {
      content: '、';
    }
  }
}
.c-jobListLv1 {
  &_item {
    & + & {
      border-top: 1px solid $color-border-base;
    }
  }
  &_title {
    display: block;
    padding: 5px 0;
    font-weight: bold;
    color: $color-font-light;
    @include link-effect;
    i {
      margin-right: 0.25em;
    }
  }
  &_collapsed {
    color: $color-font-base;
  }
}
.c-jobListLv2 {
  margin-left: 1.25em;
  &_item {
    margin-bottom: 5px;
  }
  &_title {
    font-size: 12px;
    font-weight: bold;
  }
}
.c-jobListLv3 {
  display: flex;
  flex-wrap: wrap;
  &_item {
    min-width: calc(100% / 3);
    white-space: nowrap;
    padding-right: 1em;
  }
  &_title {
  }
}

@media (max-width: $breakpoint-m) {
  .c-jobListLv3 {
    &_item {
      min-width: calc(100% / 2);
    }
  }
}

@media (max-width: $breakpoint-s) {
  .c-jobListLv3 {
    &_item {
      min-width: 100%;
    }
  }
}
</style>
